<style scoped lang="scss">
.detail-table /deep/ .cell {
  white-space: pre-line;
}
.detail-table /deep/ td,
.detail-table /deep/ th {
  padding: 20px 0;
  text-align: center;
}

.detail-table /deep/ td{
  text-align: left;
  padding: 20px;
  vertical-align: top;
}
/deep/ .ml17{
  margin-left:17px;
}
</style>
<template>
  <div class="detail-table">
    <el-table border :header-cell-style="headerCellStyle" :span-method="tableSpanMethod" :data="tableData">
      <el-table-column
        v-for="(item, index) in tableColumn"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      >
        <template slot-scope="scope">
          <div v-if="item.html" v-html="scope.row[item.prop]"></div>
          <div v-else>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="tips.text" :style="tips.style">{{ tips.text }}</div>
  </div>
</template>

<script>
export default {
  name: "service-table",
  props: {
    tableColumn: {
      type: Array,
    },
    tableData: {
      type: Array,
    },
    tableSpanMethod: {
      type: Function,
    },
    headerCellStyle: {
      type: Function,
    },
    tips: {
      type: Object,
      default: () => {
        return {
          text: "",
          style: null,
        };
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/tec/components/serviceTable.vue